/**
 * Quizz Bracelet Personnalisé
 * Version améliorée avec:
 * - Encodage URL des noms de pierres (fix #4)
 * - Gestion d'erreur AJAX (fix #5)
 * - Persistance sessionStorage (amélioration #7)
 * - Intégration Klaviyo optionnelle
 */
document.addEventListener("DOMContentLoaded", () => {
    const quizz = document.querySelector('.quizz-wrapper');

    if (quizz) {
        // Récupération des données persistantes ou initialisation
        let quizzResponse = JSON.parse(sessionStorage.getItem('quizzResponse')) || {
            "firstname": "",
            "sex": "",
            "zodiac": "",
            "ill-type": "",
            "ill": [],
            "email": "",
            "beads": []
        };

        let combinaisons = {};
        try {
            combinaisons = JSON.parse(localStorage.getItem('combinaisons')) || {};
        } catch (e) {
            console.error('Quizz: Erreur parsing combinaisons:', e);
        }
        console.log('Quizz: combinaisons chargées, clés:', Object.keys(combinaisons));

        const steps = quizz.querySelectorAll('[data-quizz-step]');
        const previousButtons = quizz.querySelectorAll('.quizz-previous, [data-quizz-start]');
        const submitButtons = quizz.querySelectorAll('[data-step-submit]');
        const quizzSubmit = quizz.querySelector('[data-quizz-submit]');
        const klaviyoForm = quizz.querySelector('.klaviyo-form, [class*="klaviyo-form"]');
        const hasKlaviyo = klaviyoForm !== null;

        // Auto-submit sur sélection radio
        const radioButtons = quizz.querySelectorAll('[name="zodiac"], [name="sex"], [name="ill-type"]');
        radioButtons.forEach(btn => {
            btn.addEventListener('click', function () {
                const currentStep = btn.closest('[data-quizz-step]');
                const submitBtn = currentStep.querySelector('[data-step-submit]');
                submitBtn.dispatchEvent(new Event('click'));
            });
        });

        // Navigation précédent
        previousButtons.forEach(btn => {
            btn.addEventListener('click', function (e) {
                e.preventDefault();
                const currentStep = btn.parentElement;
                const targetId = parseInt(btn.getAttribute('data-step-switch'));
                switchStep(currentStep, targetId);
            });
        });

        // Navigation suivant avec validation
        submitButtons.forEach(btn => {
            btn.addEventListener('click', function (e) {
                e.preventDefault();
                const currentStep = btn.parentElement;
                const targetId = parseInt(btn.getAttribute('data-step-switch'));
                const name = btn.getAttribute('data-step-submit');

                if (stepIsValid(name)) {
                    saveProgress(); // Amélioration #7: Persistance
                    switchStep(currentStep, targetId);
                }
            });
        });

        // Soumission finale
        if (quizzSubmit) {
            quizzSubmit.addEventListener('click', function () {
                const emailInput = quizz.querySelector('[step-choices="email"] [name="email"]');
                const noEmailCheckbox = quizz.querySelector('#no-email');

                if (noEmailCheckbox && noEmailCheckbox.checked) {
                    validateQuizz();
                    quizz.querySelector('[step-choices="email"]').classList.remove('error');
                } else if (emailInput && emailInput.value !== '') {
                    if (validateEmail(emailInput.value)) {
                        quizzResponse['email'] = emailInput.value;
                        quizz.querySelector('[step-choices="email"]').classList.remove('error');

                        // Klaviyo optionnel
                        if (hasKlaviyo) {
                            try {
                                klaviyoForm.querySelector('[id*="email"]').value = emailInput.value;
                                klaviyoForm.querySelector('[id*="email"]').dispatchEvent(new Event('input'));
                                klaviyoForm.querySelector('form').dispatchEvent(new Event('submit'));
                            } catch (e) {
                                console.warn('Klaviyo: Erreur lors de la soumission', e);
                            }
                        }
                        validateQuizz();
                    } else {
                        quizz.querySelector('[step-choices="email"]').classList.add('error');
                    }
                } else {
                    quizz.querySelector('[step-choices="email"]').classList.add('error');
                }
            });
        }

        function saveProgress() {
            sessionStorage.setItem('quizzResponse', JSON.stringify(quizzResponse));
        }

        function switchStep(currentStep, targetId) {
            const currentId = currentStep.getAttribute('data-quizz-step');
            const targetStep = quizz.querySelector('[data-quizz-step="' + targetId + '"]');
            const nextStep = quizz.querySelector('[data-quizz-step="' + (targetId + 1) + '"]');

            if (currentId > targetId) {
                currentStep.classList.add('quizz-step--previous');
            }

            steps.forEach(step => {
                step.classList.add('quizz-step--hidden');

                setTimeout(function () {
                    step.style.display = 'none';

                    if (currentId > targetId) {
                        currentStep.classList.add('quizz-step--previous');
                    } else {
                        targetStep.classList.add('quizz-step--next');
                    }

                    targetStep.style.display = 'flex';
                }, 500);
            });

            setTimeout(function () {
                targetStep.classList.remove('quizz-step--hidden');
                targetStep.classList.remove('quizz-step--next');
                currentStep.classList.remove('quizz-step--previous');

                if (nextStep) {
                    nextStep.classList.add('quizz-step--next');
                }

                // Re-apply ill filtering when step 6 (maux) becomes visible
                if (targetId === 6 && quizzResponse['ill-type']) {
                    filterIllChoices();
                }
            }, 600);
        }

        function filterIllChoices() {
            const illChoices = quizz.querySelectorAll('[data-ill-type]');
            illChoices.forEach(ill => {
                ill.style.display = 'none';
                const illSex = ill.getAttribute('data-ill-sex');
                const illType = ill.getAttribute('data-ill-type');
                if (illSex.includes(quizzResponse['sex']) && (quizzResponse['ill-type'].includes(illType) || quizzResponse['ill-type'] === 'both')) {
                    ill.style.display = 'block';
                }
            });
        }

        function stepIsValid(name) {
            let isValid = true;

            switch (name) {
                case 'firstname':
                    const input = quizz.querySelector('[name="firstname"]');
                    if (input.value == '') {
                        isValid = false;
                        input.classList.add('error');
                    } else {
                        quizzResponse.firstname = input.value;
                        quizz.querySelector('[data-quizz-firstname]').innerHTML = input.value;
                        if (hasKlaviyo) {
                            try {
                                klaviyoForm.querySelector('[id*="first_name"]').value = input.value;
                                klaviyoForm.querySelector('[id*="first_name"]').dispatchEvent(new Event('input'));
                            } catch (e) { }
                        }
                    }
                    break;
                case 'sex':
                    isValid = checkChoice(name, 'Sexe');
                    break;
                case 'zodiac':
                    isValid = checkChoice(name, 'Zodiac_Sign');
                    break;
                case 'ill-type':
                    isValid = checkChoice(name);
                    if (isValid) {
                        filterIllChoices();
                    }
                    break;
                case 'ill':
                    const selectedChoice = quizz.querySelectorAll('[name="' + name + '"]:checked');
                    if (selectedChoice.length > 0 && selectedChoice.length < 5) {
                        const total = [];
                        let klaviyo_value = '';
                        selectedChoice.forEach(choice => {
                            total.push(choice.value);
                            klaviyo_value = klaviyo_value + choice.value + ',';
                        });
                        quizzResponse[name] = total;
                        if (hasKlaviyo) {
                            try {
                                klaviyoForm.querySelector('[id*="Maux"]').value = klaviyo_value;
                                klaviyoForm.querySelector('[id*="Maux"]').dispatchEvent(new Event('input'));
                            } catch (e) { }
                        }
                    } else {
                        isValid = false;
                        quizz.querySelector('[step-choices="' + name + '"]').classList.add('error');
                    }
                    break;
                default:
            }

            return isValid;
        }

        function checkChoice(name, klaviyo_id = '') {
            const selectedChoice = quizz.querySelector('[name="' + name + '"]:checked');
            let isValid = true;
            if (selectedChoice) {
                quizzResponse[name] = selectedChoice.value;
                if (klaviyo_id !== '' && hasKlaviyo) {
                    try {
                        if (klaviyoForm.querySelector('[id*="' + klaviyo_id + '"]')) {
                            klaviyoForm.querySelector('[id*="' + klaviyo_id + '"]').value = selectedChoice.value;
                            klaviyoForm.querySelector('[id*="' + klaviyo_id + '"]').dispatchEvent(new Event('input'));
                        }
                    } catch (e) { }
                }
            } else {
                isValid = false;
                quizz.querySelector('[step-choices="' + name + '"]').classList.add('error');
            }

            return isValid;
        }

        function validateEmail(email) {
            const emailPattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
            return emailPattern.test(email);
        }

        function validateQuizz() {
            const quizzFinal = quizz.querySelector('[data-quizz-final]');

            steps.forEach(step => {
                step.style.display = 'none';
            });
            quizzFinal.style.display = 'flex';

            // Afficher le loader 1.5s puis les résultats
            setTimeout(function () {
                try {
                    var loaderWrapper = quizzFinal.querySelector('.quizz-final-loader-wrapper');
                    var finalContent = quizzFinal.querySelector('.quizz-final-content');
                    console.log('Quiz: loader=', loaderWrapper, 'content=', finalContent);
                    if (loaderWrapper) loaderWrapper.style.display = 'none';
                    if (finalContent) finalContent.style.display = 'block';
                    updateFinalData();
                    sessionStorage.removeItem('quizzResponse');
                } catch (e) {
                    console.error('Quiz validateQuizz error:', e);
                    // Même en cas d'erreur, afficher le contenu
                    var lw = quizzFinal.querySelector('.quizz-final-loader-wrapper');
                    var fc = quizzFinal.querySelector('.quizz-final-content');
                    if (lw) lw.style.display = 'none';
                    if (fc) fc.style.display = 'block';
                }
            }, 1500);
        }

        function updateFinalData() {
            updateFinalBeads();
            initBracelet();
            updateCrosssells();
        }

        function findBead(ill, sex) {
            var sexLower = (sex || '').toLowerCase();
            for (const [name, details] of Object.entries(combinaisons)) {
                // Vérifier corps/esprit
                var matchIll = (details.corps && details.corps.includes(ill)) || (details.esprit && details.esprit.includes(ill));
                if (!matchIll) continue;

                // Vérifier sexe (insensible à la casse, fallback si pas de champ sex)
                if (!details.sex || details.sex.length === 0) return name;
                var matchSex = details.sex.some(function(s) {
                    return (s || '').toLowerCase() === sexLower;
                });
                if (matchSex) return name;
            }
            return null;
        }

        function updateFinalBeads() {
            const finalBeads = quizz.querySelector('.quizz-final-beads');
            if (!finalBeads) return;

            finalBeads.innerHTML = '';
            quizzResponse['ill'].forEach(ill => {
                const beadName = findBead(ill, quizzResponse['sex']);
                if (!beadName || !combinaisons[beadName]) return;

                const beadData = combinaisons[beadName];
                if (finalBeads.querySelector('[data-bead-name="' + beadName + '"]')) {
                    const newLabel = document.createElement('span');
                    newLabel.classList.add('quizz-final-bead-subtitle');
                    newLabel.innerHTML = '(' + ill + ')';
                    finalBeads.querySelector('[data-bead-name="' + beadName + '"]').append(newLabel);
                } else {
                    const bead = document.createElement('div');
                    bead.classList.add('quizz-final-bead');
                    bead.setAttribute('data-bead-name', beadName);
                    bead.innerHTML = `<img src="${beadData['image']}" alt="${ill}" class="quizz-final-bead-image" />
                            <strong class="quizz-final-bead-title">${beadName}</strong>
                            <span class="quizz-final-bead-subtitle">(${ill})</span>`;
                    finalBeads.append(bead);
                    quizzResponse['beads'].push(beadName);
                }
            });
        }

        function initBracelet() {
            const braceletWrapper = quizz.querySelector('.quizz-final-bracelet');
            if (!braceletWrapper) return;

            const beadSize = '6mm';
            const beadsNumber = 31;

            const diametreBead = parseInt(beadSize) * 4;
            const diametreBracelet = (diametreBead * beadsNumber) / Math.PI;

            const centerX = diametreBracelet / 2;
            const centerY = diametreBracelet / 2;

            const dynamicBracelet = document.createElement('div');
            dynamicBracelet.classList.add('dynamic-bracelet');
            dynamicBracelet.setAttribute(
                'style',
                '--bracelet-size:' + diametreBracelet + 'px;' +
                '--bead-size:' + diametreBead + 'px'
            );
            braceletWrapper.append(dynamicBracelet);

            for (let i = 0; i < beadsNumber; i++) {
                const angle = (i / beadsNumber) * Math.PI * 2;
                const x = centerX + (diametreBracelet / 2) * Math.cos(angle);
                const y = centerY + (diametreBracelet / 2) * Math.sin(angle);

                const bead = document.createElement('span');
                bead.classList.add('dynamic-bracelet__bead');
                bead.style.top = y - diametreBead / 2 + 'px';
                bead.style.left = x - diametreBead / 2 + 'px';

                dynamicBracelet.appendChild(bead);
            }

            initBraceletButton();
            updateBracelet();
        }

        function initBraceletButton() {
            const finalButton = quizz.querySelector('.quizz-final-button');
            if (!finalButton) return;

            const braceletLink = finalButton.getAttribute('href');
            const selectedBeads = quizzResponse['beads'];
            let newLink = braceletLink;

            // Conserver le preview_theme_id si on est en preview
            const currentParams = new URLSearchParams(window.location.search);
            const previewId = currentParams.get('preview_theme_id');
            if (previewId) {
                newLink = newLink + '?preview_theme_id=' + previewId;
            }

            // Encodage URL des noms de pierres
            var separator = previewId ? '&' : '?';
            if (selectedBeads[0]) {
                newLink = newLink + separator + "b1=" + encodeURIComponent(selectedBeads[0]);
                separator = '&';
            }
            if (selectedBeads[1]) {
                newLink = newLink + "&b2=" + encodeURIComponent(selectedBeads[1]);
            }
            if (selectedBeads[2]) {
                newLink = newLink + "&b3=" + encodeURIComponent(selectedBeads[2]);
            }
            if (selectedBeads[3]) {
                newLink = newLink + "&b4=" + encodeURIComponent(selectedBeads[3]);
            }

            finalButton.setAttribute('href', newLink);

            // Sauvegarder aussi dans sessionStorage (fallback cross-theme)
            sessionStorage.setItem('quizzBeads', JSON.stringify(selectedBeads));
        }

        function updateBracelet() {
            const beads = quizz.querySelectorAll('.dynamic-bracelet__bead');
            const beadsNumber = beads.length;
            let nextBeadType = 1;

            const selectedBeads = quizzResponse['beads'];

            let image1 = selectedBeads[0] && combinaisons[selectedBeads[0]] ? combinaisons[selectedBeads[0]]['image_bead'] : null;
            let image2 = selectedBeads[1] && combinaisons[selectedBeads[1]] ? combinaisons[selectedBeads[1]]['image_bead'] : null;
            let image3 = selectedBeads[2] && combinaisons[selectedBeads[2]] ? combinaisons[selectedBeads[2]]['image_bead'] : null;
            let image4 = selectedBeads[3] && combinaisons[selectedBeads[3]] ? combinaisons[selectedBeads[3]]['image_bead'] : null;

            beads.forEach(bead => {
                switch (nextBeadType) {
                    case 1:
                        if (image1) {
                            bead.style.backgroundImage = 'url(' + image1 + ')';
                        } else {
                            bead.style.backgroundImage = 'none';
                        }
                        if (image2) nextBeadType = 2;
                        break;
                    case 2:
                        bead.style.backgroundImage = 'url(' + image2 + ')';
                        nextBeadType = image3 ? 3 : 1;
                        break;
                    case 3:
                        bead.style.backgroundImage = 'url(' + image3 + ')';
                        nextBeadType = image4 ? 4 : 1;
                        break;
                    case 4:
                        bead.style.backgroundImage = 'url(' + image4 + ')';
                        nextBeadType = 1;
                        break;
                }

                bead.style.border = '0';
            });
        }

        function updateCrosssells() {
            const finalStep = quizz.querySelector('[data-quizz-final]');
            if (!finalStep) return;

            quizzResponse['beads'].forEach(bead => {
                if (!combinaisons[bead]) return;

                const crosssell = document.createElement('div');
                crosssell.classList.add('quizz-final-crosssell');
                let html = `<strong class="quizz-final-crosssell-title">${bead}</strong>
              <div class="quizz-final-crosssell-products">`;

                combinaisons[bead]['cross_sells'].forEach(product => {
                    html = html + `<a href="${product.url}" class="quizz-final-crosssell-product">
                <img src="${product.thumbnail}" alt="${product.name}" class="quizz-final-crosssell-product-image" />
                <div class="quizz-final-crosssell-product-content">
                  <strong class="quizz-final-crosssell-product-name">${product.name}</strong>
                  <span class="quizz-final-crosssell-product-price">
                    <strong>${product.price}€</strong>`;
                    if (product.old_price) {
                        html = html + `<span class="quizz-final-crosssell-product-price-old">${product.old_price}€</span>`;
                    }
                    html = html + `</span>
                </div>
              </a>`;
                });

                html = html + `</div>
              <a href="${combinaisons[bead]['collection_url']}" class="quizz-final-crosssell-link">Voir toute la collection "${bead}"
                <svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 512 512">
                  <path fill="currentColor" d="M201.373 438.627l-160-160c-12.497-12.496-12.497-32.758 0-45.255l160-160c12.497-12.496 32.758-12.496 45.255 0s12.497 32.758 0 45.255l-105.373 105.373h306.745c17.673 0 32 14.327 32 32s-14.327 32-32 32h-306.745l105.373 105.373c6.248 6.248 9.372 14.438 9.372 22.627s-3.124 16.379-9.372 22.627c-12.497 12.497-32.758 12.497-45.255 0z"/>
                </svg>
              </a>`;

                crosssell.innerHTML = html;
                finalStep.append(crosssell);
            });
        }
    }
});
